export default defineAppConfig({
    ui: {
        colors: {
            primary: 'red',
            neutral: 'zinc',
        },
        modal: {
            slots: {
                overlay: 'fixed inset-0 bg-inverted/75',
            },
        },
        table: {
            variants: {
                pinned: {
                    true: {
                        th: 'sticky bg-default/95 z-1',
                        td: 'sticky bg-default/95 z-1',
                    },
                },
                sticky: {
                    true: {
                        thead: 'sticky top-0 inset-x-0 bg-default z-1',
                    },
                    header: {
                        thead: 'sticky top-0 inset-x-0 bg-default/75 z-1',
                    },
                },
            },
        },
    },
})
